import type { MakeStylesHook, StyleRules } from '@egr/xbox/utils/tss-react';
import type { Theme } from '@mui/material/styles';

import FooterLink from './FooterLink';
import { FooterInfo } from './components/FooterInfo';
import { useFooterLinks } from './hooks/usefooterLinks';

import { makeStyles } from '@egr/xbox/utils/tss-react';

type FooterClasses = 'root';

function styles(theme: Theme): StyleRules<FooterClasses> {
    return {
        root: {
            bottom: 0,
            width: '100%',
            display: 'flex',
            paddingBottom: 8,
            paddingTop: 8,
            paddingLeft: 24,
            paddingRight: 24,
            backgroundColor: theme.palette.common.white,
            color: theme.palette.grey[700],
            flexWrap: 'wrap',
            borderTop: 1,
            borderTopStyle: 'solid',
            borderTopColor: theme.palette.divider,
            zIndex: 9999,
        },
    };
}
const useStyles: MakeStylesHook<FooterClasses> = makeStyles({ name: 'Footer' })(styles);

export default function StickyFooter() {
    const { classes } = useStyles();

    const links = useFooterLinks();

    return (
        <div className={classes.root}>
            {links.map((link, index) => (
                <FooterLink
                    key={index}
                    href={link.href}
                    onClick={link.onClick}
                    isLast={index === links.length - 1}
                    title={link.label}
                    id={link.id}
                />
            ))}
            <div style={{ width: 50 }}></div>
            <div style={{ right: 0 }}>
                <FooterInfo />
            </div>
        </div>
    );
}
